var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Cursor component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCursor extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.77258 1.03457C3.19401 0.93689 3.63439 0.95939 4.04367 1.09952L21.6311 7.14324C21.9838 7.17687 22.3157 7.33211 22.5683 7.58478C22.8555 7.87193 23.0168 8.26138 23.0168 8.66746C23.0168 9.07354 22.8555 9.46299 22.5683 9.75013C22.3175 10.001 21.9885 10.1558 21.6386 10.1909L13.2479 13.2354L10.277 21.6429C10.2426 21.9942 10.0876 22.3246 9.83582 22.5764C9.54868 22.8635 9.15922 23.0249 8.75314 23.0249C8.34706 23.0249 7.95761 22.8635 7.67047 22.5764C7.41818 22.3241 7.26303 21.9929 7.22908 21.6407L1.10708 4.0361C0.966953 3.62682 0.944461 3.18644 1.04214 2.76501C1.13983 2.34358 1.35378 1.958 1.65967 1.6521C1.96557 1.34621 2.35115 1.13226 2.77258 1.03457ZM3.55743 2.51852C3.41376 2.46941 3.2592 2.46155 3.11128 2.49583C2.96324 2.53015 2.82779 2.60531 2.72033 2.71276C2.61288 2.82022 2.53772 2.95567 2.5034 3.10371C2.4692 3.25127 2.47694 3.40543 2.52573 3.54881C2.52589 3.54928 2.52605 3.54976 2.52622 3.55023L8.6804 21.2474C8.70794 21.3266 8.72201 21.4099 8.72201 21.4937C8.72201 21.502 8.72529 21.5099 8.73113 21.5157C8.73696 21.5216 8.74488 21.5249 8.75314 21.5249C8.7614 21.5249 8.76932 21.5216 8.77516 21.5157C8.781 21.5099 8.78428 21.502 8.78428 21.4937C8.78428 21.4086 8.79877 21.3241 8.82713 21.2438L11.9517 12.4014C12.0264 12.1898 12.192 12.0228 12.403 11.9462L21.2299 8.74357C21.3119 8.71381 21.3984 8.69859 21.4857 8.69859C21.4939 8.69859 21.5018 8.69531 21.5077 8.68947C21.5135 8.68364 21.5168 8.67572 21.5168 8.66746C21.5168 8.6592 21.5135 8.65128 21.5077 8.64544C21.5018 8.6396 21.4939 8.63632 21.4857 8.63632C21.4027 8.63632 21.3204 8.62256 21.2419 8.59561L3.55743 2.51852C3.55731 2.51848 3.55756 2.51856 3.55743 2.51852Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCursor.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCursor.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCursor.prototype, "size", void 0);
if (customElements.get('cat-icon-cursor') === undefined) {
    customElements.define('cat-icon-cursor', BlocksIconCursor);
}
